module.exports = __webpack_public_path__ + "885a66164ff7243bfd45aab5a2ebc4e3.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/slots/betsolutions/assets/08-Betsolutions-The-Mystery-of-Faberge.png
// module id = 1730
// module chunks = 2